import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { PageHeader, Popconfirm, message, Tooltip, Row, Col, Empty, Spin } from "antd";
import {
  EditOutlined,
  EyeOutlined,
  CheckCircleOutlined,
  StopOutlined,
  PlusOutlined,
  ArrowLeftOutlined,
  AppstoreOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import {
  TableItem,
  ButtonItem,
  SegmentedItem,
} from "../../../Components/Items";
import DynamicCardForm from "../../../Components/DynamicCardForm";
import ModalCategoria from "./ModalCategoria/ModalCategoria";
import ModalValores from "./ModalValores/ModalValores";

const TIPO_DATO_LABEL = {
  numero: "Número",
  texto: "Texto",
  fecha: "Fecha",
  booleano: "Booleano",
};

const BIWO_CYAN = "#00BFD6";
const BIWO_CYAN_LIGHT = "#E6F9FC";
const BIWO_CYAN_DARK = "#008FA0";

class ConfiguracionCategoriasInsumos extends Component {
  state = {
    loadingFamilias: false,
    loadingCategorias: false,
    todasFamilias: [],
    familiaSeleccionada: "todas",
    todasCategorias: [],
    valor: 1,
    modalCategoria: false,
    modoModal: "",
    categoriaId: null,
    categoriaPadrePreseleccionada: null,
    modalValores: false,
    modalValoresCategoria: null,
  };

  componentDidMount() {
    this.consultarFamilias();
    this.consultarCategorias();
  }

  consultarFamilias = async () => {
    this.setState({ loadingFamilias: true });
    try {
      const res = await axios.post(
        "familias/selectFamilias",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      const familias = Array.isArray(res.data) ? res.data : [];
      this.setState({ todasFamilias: familias });
    } catch (err) {
      console.error("Error al consultar familias:", err);
      this.setState({ todasFamilias: [] });
    } finally {
      this.setState({ loadingFamilias: false });
    }
  };

  consultarCategorias = async (familiaId = this.state.familiaSeleccionada) => {
    this.setState({ loadingCategorias: true });
    try {
      const res = await axios.post(
        "categoriasInsumo/selectTodasCategoriasInsumo",
        {
          empresaId: this.props.empresaId,
          familiaId,
          valor: this.state.valor,
        },
        { headers: this.props.headersToken }
      );
      if (res.data && res.data.success === 2) {
        this.setState({ todasCategorias: res.data.categorias || [] });
      } else {
        this.setState({ todasCategorias: [] });
      }
    } catch (err) {
      console.error("Error al consultar categorías:", err);
      this.setState({ todasCategorias: [] });
    } finally {
      this.setState({ loadingCategorias: false });
    }
  };

  seleccionarFamilia = (familiaId) => {
    this.setState({ familiaSeleccionada: familiaId }, () => {
      this.consultarCategorias(familiaId);
    });
  };

  agregarCategoria = () => {
    this.setState({
      modalCategoria: true,
      modoModal: "agregar",
      categoriaId: null,
      categoriaPadrePreseleccionada: null,
    });
  };

  agregarHijaA = (padreId) => {
    this.setState({
      modalCategoria: true,
      modoModal: "agregar",
      categoriaId: null,
      categoriaPadrePreseleccionada: padreId,
    });
  };

  editarCategoria = (id) => {
    this.setState({
      modalCategoria: true,
      modoModal: "editar",
      categoriaId: id,
      categoriaPadrePreseleccionada: null,
    });
  };

  cerrarModalCategoria = () => {
    this.setState({
      modalCategoria: false,
      categoriaId: null,
      categoriaPadrePreseleccionada: null,
    });
    this.consultarCategorias();
  };

  abrirModalValores = (categoria) => {
    this.setState({ modalValores: true, modalValoresCategoria: categoria });
  };

  cerrarModalValores = () => {
    this.setState({ modalValores: false, modalValoresCategoria: null });
  };

  deshabilitarCategoria = (id) => {
    axios
      .post(
        "categoriasInsumo/deshabilitarCategoriaInsumo",
        { categoriaInsumoId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data && res.data.success === 2) {
          const afec = res.data.entidadesAfectadas || {};
          const cats = afec.categorias || 1;
          const vals = afec.valores || 0;
          if (cats > 1 || vals > 0) {
            message.success(
              `Deshabilitado. ${cats} categoría${cats === 1 ? "" : "s"} y ${vals} valor${vals === 1 ? "" : "es"} en cascada.`
            );
          } else {
            message.success("Categoría deshabilitada");
          }
        } else {
          message.error((res.data && res.data.message) || "No se pudo deshabilitar");
        }
        this.consultarCategorias();
      });
  };

  habilitarCategoria = (id) => {
    axios
      .post(
        "categoriasInsumo/habilitarCategoriaInsumo",
        { categoriaInsumoId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data && res.data.success === 2) {
          const afec = res.data.entidadesAfectadas || {};
          const cats = afec.categorias || 1;
          const vals = afec.valores || 0;
          if (cats > 1 || vals > 0) {
            message.success(
              `Habilitado. ${cats} categoría${cats === 1 ? "" : "s"} y ${vals} valor${vals === 1 ? "" : "es"} reactivados.`
            );
          } else {
            message.success("Categoría habilitada");
          }
        } else {
          message.error((res.data && res.data.message) || "No se pudo habilitar");
        }
        this.consultarCategorias();
      });
  };

  renderFamiliaItem(key, label, icon) {
    const selected = this.state.familiaSeleccionada === key;
    return (
      <div
        key={key}
        className={`fam-item ${selected ? "fam-item-selected" : ""}`}
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => this.seleccionarFamilia(key)}
      >
        <span className="fam-item-icon">{icon}</span>
        <span className="fam-item-label">{label}</span>
        {selected && <span className="fam-item-dot" />}
      </div>
    );
  }

  renderFamiliasMenu() {
    return (
      <Spin spinning={this.state.loadingFamilias}>
        <style>{`
          .fam-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px 12px;
            margin-bottom: 6px;
            border-radius: 8px;
            cursor: pointer;
            transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
            border: 1px solid rgba(0, 191, 214, 0);
            font-size: 13px;
            font-weight: 500;
            color: #444;
            background-color: transparent;
            outline: none;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
          }
          .fam-item:hover {
            background-color: #f5fbfc;
            border-color: rgba(0, 191, 214, 0.25);
            color: ${BIWO_CYAN_DARK};
          }
          .fam-item:focus,
          .fam-item:focus-visible,
          .fam-item:active {
            outline: none;
            box-shadow: none;
          }
          .fam-item-icon {
            width: 28px;
            height: 28px;
            border-radius: 6px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: #f0f2f5;
            color: ${BIWO_CYAN_DARK};
            font-size: 14px;
            flex-shrink: 0;
            transition: background 0.18s ease, color 0.18s ease;
          }
          .fam-item-label {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .fam-item-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: ${BIWO_CYAN};
            flex-shrink: 0;
          }
          .fam-item-selected,
          .fam-item-selected:hover {
            background-color: ${BIWO_CYAN_LIGHT};
            background-image: linear-gradient(135deg, ${BIWO_CYAN_LIGHT} 0%, #f0fcff 100%);
            border-color: rgba(0, 191, 214, 1);
            color: ${BIWO_CYAN_DARK};
            box-shadow: 0 2px 6px rgba(0, 191, 214, 0.15);
          }
          .fam-item-selected .fam-item-icon {
            background: ${BIWO_CYAN};
            color: #fff;
          }
        `}</style>
        <div
          style={{
            maxHeight: "65vh",
            overflowY: "auto",
            paddingRight: 4,
          }}
        >
          {this.renderFamiliaItem(
            "todas",
            "Todas las familias",
            <AppstoreOutlined />
          )}
          {this.state.todasFamilias.length > 0 && (
            <div
              style={{
                height: 1,
                background: "#f0f0f0",
                margin: "8px 4px 10px",
              }}
            />
          )}
          {this.state.todasFamilias.map((f) =>
            this.renderFamiliaItem(f._id, f.nombre, <FolderOpenOutlined />)
          )}
          {!this.state.loadingFamilias &&
            this.state.todasFamilias.length === 0 && (
              <div
                style={{
                  fontSize: 12,
                  color: "#999",
                  textAlign: "center",
                  padding: "12px 4px",
                }}
              >
                Sin familias registradas
              </div>
            )}
        </div>
      </Spin>
    );
  }

  ordenarJerarquicamente(categorias) {
    // Ordena por: cada PRINCIPAL seguido de sus HIJAS, luego las hijas sueltas (sin padre) al final.
    const cmpNombre = (a, b) => (a.nombre || "").localeCompare(b.nombre || "");
    const principales = categorias.filter((c) => c.esPrincipal).sort(cmpNombre);
    const hijas = categorias.filter((c) => !c.esPrincipal);
    const hijasPorPadre = new Map();
    const sueltas = [];
    hijas.forEach((h) => {
      const padreId = h.categoriaPadreId ? h.categoriaPadreId.toString() : null;
      if (padreId && categorias.some((c) => c._id.toString() === padreId && c.esPrincipal)) {
        if (!hijasPorPadre.has(padreId)) hijasPorPadre.set(padreId, []);
        hijasPorPadre.get(padreId).push(h);
      } else {
        sueltas.push(h);
      }
    });
    hijasPorPadre.forEach((arr) => arr.sort(cmpNombre));
    sueltas.sort(cmpNombre);

    const result = [];
    principales.forEach((p) => {
      result.push(p);
      const sus = hijasPorPadre.get(p._id.toString()) || [];
      sus.forEach((h) => result.push(h));
    });
    sueltas.forEach((s) => result.push(s));
    return result;
  }

  render() {
    const familiaActual =
      this.state.familiaSeleccionada === "todas"
        ? "Todas las familias"
        : this.state.todasFamilias.find(
            (f) => f._id === this.state.familiaSeleccionada
          )?.nombre || "—";

    const categoriasOrdenadas = this.ordenarJerarquicamente(
      this.state.todasCategorias
    );

    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        buscar: "nombre",
        render: (value, record) => {
          const esHijaConPadre = !record.esPrincipal && record.categoriaPadreId;
          const contenido = record.descripcion ? (
            <Tooltip title={record.descripcion} placement="topLeft">
              <span style={{ fontWeight: record.esPrincipal ? 700 : 500 }}>{value}</span>
            </Tooltip>
          ) : (
            <span style={{ fontWeight: record.esPrincipal ? 700 : 500 }}>{value}</span>
          );

          return (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {esHijaConPadre && (
                <span
                  style={{
                    color: "#bbb",
                    fontSize: 14,
                    marginLeft: 12,
                  }}
                  title="Hija de una categoría principal"
                >
                  └
                </span>
              )}
              {contenido}
              {record.esPrincipal && (
                <span
                  style={{
                    display: "inline-block",
                    padding: "1px 7px",
                    borderRadius: 8,
                    background: BIWO_CYAN,
                    color: "#fff",
                    fontSize: 10,
                    fontWeight: 600,
                    letterSpacing: "0.3px",
                    textTransform: "uppercase",
                  }}
                >
                  Principal
                </span>
              )}
            </div>
          );
        },
      },
      {
        title: "Tipo de dato",
        dataIndex: "tipoDato",
        key: "tipoDato",
        render: (value, record) => {
          if (record.esPrincipal) {
            return <span style={{ color: "#bbb" }}>—</span>;
          }
          return (
            <span
              style={{
                display: "inline-block",
                padding: "2px 8px",
                borderRadius: 10,
                background: BIWO_CYAN_LIGHT,
                color: BIWO_CYAN_DARK,
                fontSize: 11,
                fontWeight: 500,
              }}
            >
              {TIPO_DATO_LABEL[value] || value}
            </span>
          );
        },
        width: "18%",
      },
      {
        title: "Aplica a",
        dataIndex: "familiaIds",
        key: "familiaIds",
        render: (familiaIds) => {
          if (!familiaIds || familiaIds.length === 0) {
            return (
              <span style={{ color: BIWO_CYAN_DARK, fontWeight: 500 }}>
                Todas las familias
              </span>
            );
          }
          const nombres = familiaIds
            .map(
              (id) =>
                this.state.todasFamilias.find(
                  (f) => f._id.toString() === id.toString()
                )?.nombre
            )
            .filter(Boolean);
          return nombres.length > 0
            ? nombres.join(", ")
            : `${familiaIds.length} familia(s)`;
        },
      },
      {
        title: "Acción",
        key: "acciones",
        align: "center",
        width: "22%",
        onHeaderCell: () => ({
          style: { textAlign: "center", padding: "4px" },
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: "center", padding: "4px" },
        }),
        render: (value, record) => {
          const buttons = [];

          if (record.esPrincipal && this.props.permisoAgregarCategoria) {
            buttons.push(
              <Tooltip
                key={`agregar-hija-${record._id}`}
                title="Agregar categoría hija"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  type="default"
                  size="small"
                  olivo
                  icon={<PlusOutlined />}
                  onClick={() => this.agregarHijaA(record._id)}
                />
              </Tooltip>
            );
          }

          if (!record.esPrincipal) {
            buttons.push(
              <Tooltip
                key={`valores-${record._id}`}
                title="Ver / Editar Valores"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  type="default"
                  size="small"
                  azul
                  icon={<EyeOutlined />}
                  onClick={() => this.abrirModalValores(record)}
                />
              </Tooltip>
            );
          }

          if (this.props.permisoEditarCategoria) {
            buttons.push(
              <Tooltip
                key={`editar-${record._id}`}
                title="Editar"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarCategoria(record._id)}
                />
              </Tooltip>
            );
          }

          if (this.props.permisoHabDesCategoria) {
            if (record.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${record._id}`}
                  title={
                    record.esPrincipal
                      ? "Esta es una categoría principal. Se deshabilitarán también todas sus categorías hijas y sus valores. ¿Continuar?"
                      : "¿Seguro que quieres deshabilitar esta categoría? Los valores asociados también se deshabilitarán."
                  }
                  onConfirm={() => this.deshabilitarCategoria(record._id)}
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip
                    title="Deshabilitar"
                    placement="top"
                    overlayInnerStyle={{
                      fontSize: "10px",
                      padding: "1px 5px",
                      minHeight: "auto",
                    }}
                  >
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    />
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${record._id}`}
                  title={
                    record.esPrincipal
                      ? "Esta es una categoría principal. Se habilitarán también todas sus categorías hijas y sus valores. ¿Continuar?"
                      : "¿Habilitar esta categoría? Se reactivarán también sus valores asociados."
                  }
                  onConfirm={() => this.habilitarCategoria(record._id)}
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip
                    title="Habilitar"
                    placement="top"
                    overlayInnerStyle={{
                      fontSize: "10px",
                      padding: "1px 5px",
                      minHeight: "auto",
                    }}
                  >
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    />
                  </Tooltip>
                </Popconfirm>
              );
            }
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Configuración de Categorías de Insumos"
          onBack={() => this.props.history.push("/panel/insumos")}
          backIcon={<ArrowLeftOutlined />}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Activas", value: 1 },
                    { label: "Deshabilitadas", value: 2 },
                    { label: "Todas", value: 3 },
                  ]}
                  value={this.state.valor}
                  onChange={(value) =>
                    this.setState({ valor: value }, () =>
                      this.consultarCategorias()
                    )
                  }
                />
              )}
              {this.props.permisoAgregarCategoria && (
                <ButtonItem
                  type="primary"
                  olivo
                  icon={<PlusOutlined />}
                  onClick={this.agregarCategoria}
                  className="botonAgregar"
                >
                  Agregar Categoría
                </ButtonItem>
              )}
            </div>
          }
        />

        <Row gutter={[8, 8]}>
          <Col xs={24} md={7} lg={6}>
            <DynamicCardForm title="Familias" span={24} noMargin>
              {this.renderFamiliasMenu()}
            </DynamicCardForm>
          </Col>
          <Col xs={24} md={17} lg={18}>
            <DynamicCardForm
              title={`Categorías de: ${familiaActual}`}
              span={24}
              noMargin
            >
              <TableItem
                loading={this.state.loadingCategorias}
                size="small"
                dataSource={categoriasOrdenadas}
                columns={columns}
                rowKey="_id"
                pagination={true}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Sin categorías para esta familia"
                    />
                  ),
                }}
              />
            </DynamicCardForm>
          </Col>
        </Row>

        <ModalCategoria
          visible={this.state.modalCategoria}
          onClose={this.cerrarModalCategoria}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          modo={this.state.modoModal}
          categoriaId={this.state.categoriaId}
          todasFamilias={this.state.todasFamilias}
          familiaPreseleccionada={
            this.state.familiaSeleccionada !== "todas"
              ? this.state.familiaSeleccionada
              : null
          }
          categoriaPadrePreseleccionada={this.state.categoriaPadrePreseleccionada}
        />

        <ModalValores
          visible={this.state.modalValores}
          onClose={this.cerrarModalValores}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          categoria={this.state.modalValoresCategoria}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoAgregarCategoria:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a0c8e6b95cdbbe290cdf783"
    )?.activado,
  permisoEditarCategoria:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a0c8e7a95cdbbe290cdf7a8"
    )?.activado,
  permisoHabDesCategoria:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a0c8e9995cdbbe290cdf815"
    )?.activado,
});

export default connect(mapStateToProps)(ConfiguracionCategoriasInsumos);
